import trustarcUsCssUrl from '@/styles/trustarc-us.css?url';

type TrustArcBindMap = {
  region?: string;
  geo?: string;
  country?: string;
};

type TrustArcState = {
  hasRunOnce: boolean;
  intervalId: number | null;
};

const TRUSTARC_STATE: TrustArcState = {
  hasRunOnce: false,
  intervalId: null
};

const TRUSTARC_US_CSS = trustarcUsCssUrl;

function applyUSCustomization() {
  if (TRUSTARC_STATE.hasRunOnce) {
    return;
  }

  const w = window as unknown as {
    truste?: {
      eu?: unknown;
    };
  };

  if (!w.truste || !w.truste.eu) {
    return;
  }

  const eu = w.truste.eu as { bindMap?: TrustArcBindMap };

  if (!eu.bindMap) {
    return;
  }

  const bindMap = eu.bindMap;

  let region = bindMap.region || bindMap.geo || bindMap.country || '';

  region = region.toUpperCase();

  if (region !== 'US') {
    TRUSTARC_STATE.hasRunOnce = true;
    if (TRUSTARC_STATE.intervalId !== null) {
      clearInterval(TRUSTARC_STATE.intervalId);
    }
    return;
  }

  const container = document.getElementById('trustarc_container');

  if (container) {
    container.classList.add('trustarc-us');
  }

  const existingLink = document.getElementById('pli-trustarc-theme');
  if (existingLink && existingLink.parentNode) {
    existingLink.parentNode.removeChild(existingLink);
  }

  const link = document.createElement('link');
  link.id = 'pli-trustarc-theme';
  link.rel = 'stylesheet';
  link.href = TRUSTARC_US_CSS;

  document.head.appendChild(link);

  TRUSTARC_STATE.hasRunOnce = true;
  if (TRUSTARC_STATE.intervalId !== null) {
    clearInterval(TRUSTARC_STATE.intervalId);
  }
}

export function initTrustArcCustomCSS() {
  if (TRUSTARC_STATE.intervalId !== null) {
    return;
  }

  TRUSTARC_STATE.intervalId = window.setInterval(applyUSCustomization, 20);
}
